import IntroducerLabel from 'components/introducer_label'
import IntroducerSelector from 'components/introducer_selector'
import Recruiter from 'entities/recruiter'
import { trim } from 'lodash'
import PropTypes from 'prop-types'
import PubSub from 'pubsub-js'
import React, { Component, Fragment } from 'react'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'

export default class DirectIntroductionIntroducerSelector extends Component {
  constructor(props) {
    super(props)

    this.state = {
      introducer: props.introducer,
      keyword: null
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    const { introducer } = this.state

    if (introducer) {
      if (!prevState.introducer) {
        // 紹介者がセットされたら通知する
        PubSub.publish(IntroducerSelector.TOPIC_DESELECT_INTRODUCER)
      }
    } else if (prevState.introducer) {
      // 紹介者が削除されたら通知する
      PubSub.publish(IntroducerSelector.TOPIC_SELECT_INTRODUCER)
    }
  }

  handleChangeInput(e) {
    const value = trim(e.target.value)
    const keyword = value && value.length !== 0 ? value : null

    this.setState({
      keyword
    })
  }

  handleSelectIntroducer(introducer) {
    const { onUpdate } = this.props

    this.setState({
      introducer,
      keyword: null
    })

    this.input.value = introducer.name
    onUpdate(introducer)
  }

  handleDeselectIntroducer() {
    const { onUpdate } = this.props

    this.setState({
      introducer: null,
      keyword: null
    })

    this.input.value = null
    onUpdate()
  }

  render() {
    const { companyToken, deviceName, groupToken, offerToken, selectable } = this.props
    const { introducer, keyword } = this.state

    return (
      <Fragment>
        <IntroducerLabel
          device_name={deviceName}
          introducer={introducer}
          selectable={selectable}
          onClickDeselect={() => this.handleDeselectIntroducer()}
        />
        <div className="form-group-content" style={{ display: introducer ? 'none' : 'block' }}>
          <input
            ref={ref => {
              this.input = ref
            }}
            type="text"
            className="form-control"
            defaultValue={keyword}
            placeholder={I18n.t('offers.pages.direct_introduction_introducer_selector.name.placeholder')}
            onKeyUp={e => this.handleChangeInput(e)}
            onCompositionEnd={e => this.handleChangeInput(e)}
          />
          <IntroducerSelector
            company_token={companyToken}
            group_token={groupToken}
            keyword={keyword}
            offer_token={offerToken}
            selectable={selectable}
            onSelectIntroducer={newIntroducer => this.handleSelectIntroducer(newIntroducer)}
          />
        </div>
        <input
          type="hidden"
          name="direct_introduction[cooperation][recruiter_id]"
          defaultValue={introducer ? introducer.id : null}
        />
      </Fragment>
    )
  }
}

DirectIntroductionIntroducerSelector.propTypes = {
  companyToken: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  groupToken: PropTypes.string.isRequired,
  introducer: propTypeInstantiableTo(Recruiter),
  offerToken: PropTypes.string.isRequired,
  selectable: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired
}

DirectIntroductionIntroducerSelector.defaultProps = {
  introducer: null
}
